<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">{{ (removing) ? 'Brisanje v teku...' : 'Izbrišem vse lete?' }}</span>
      </v-card-title>
      <v-card-text>
        <v-container v-if="removing">
          <v-row>
            <v-col style="display: flex; align-items: center; justify-content: center;">
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
        <v-row v-else>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="pb-0">
            <v-btn color="primary" text @click="dialog = false">
              Zapri
            </v-btn>
            <v-btn class="elevation-0 ml-2" color="error" @click="remove">
              <v-icon>mdi-delete</v-icon>
              Pobriši
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    removing: false
  }),
  mounted () {
  },
  methods: {
    show () {
      this.dialog = true
      this.removing = false
    },
    remove () {
      this.removing = true

      this.$axios.get('flights/clear')
        .then(response => {
          const data = response.data.result

          this.dialog = false
          this.removing = false
        })
        .catch(error => {
          console.log(error)
          this.dialog = false
          this.removing = false
        })
    }
  },
  computed: {
  }
}
</script>
<style scoped>
</style>
